






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DialogWrapper extends Vue {
  public form = {};
  private visible = false;

  public open(form: any) {
    this.form = form;
    this.visible = true;
    return new Promise((resolve, reject) => {
      let submitted = false;
      this.submit = () => {
        this.visible = false;
        submitted = true;
        resolve(this.form);
      };

      this.close = () => {
        this.visible = false;
        if (!submitted) {
          reject('Dialog is closed.');
        }
      };
    });
  }

  // ダミー
  public close() { return; }
  public submit() { return; }
}
